import { render, staticRenderFns } from "./t_benke.vue?vue&type=template&id=0a5b26e9&scoped=true"
import script from "./t_benke.vue?vue&type=script&lang=js"
export * from "./t_benke.vue?vue&type=script&lang=js"
import style0 from "./t_benke.vue?vue&type=style&index=0&id=0a5b26e9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5b26e9",
  null
  
)

export default component.exports